import { colors } from 'utils/colors'
import { Icon } from '../icon'
import { HStack } from '../Stack'
import { Caption } from '../Typography'

export function DataEncrypted() {
  return (
    <HStack css={{ alignSelf: 'center' }}>
      <Icon name="LockClosed" color={colors.gray[500]} />
      <Caption>All data encrypted</Caption>
    </HStack>
  )
}
